export enum tableStatusCourse {
  all = 0,
  PreEnrollment = 1,
  Enrollment = 2,
  Frozen = 3,
  Canceled = 4,
  Pending = 5,
  Removed = 6,
  RestarEnrollment = 7
}
